import TratamentosConcluidosIcon from '@/components/icons/IndicadoresEsb/Estrategicos/TratamentosConcluidos.vue'

export default {
  value: 'b2',
  label: 'Tratamento odontológico',
  iconType: 'component',
  iconComponent: TratamentosConcluidosIcon,
  buscaAtiva: {
    // a: ({ cidadao, formatDate }) =>
    //   `Cidadão ${cidadao?.no_cidadao || '-'} nascido em ${
    //     cidadao?.dt_nascimento ? formatDate(cidadao.dt_nascimento) : '-'
    //   }.`,
    a: ({ perfilEsfOuEmulti }) =>
      perfilEsfOuEmulti
        ? 'Encaminhar para realizar e registrar a "consulta de retorno" ou o "tratamento concluído" no atendimento odontológico (tratamento em andamento).'
        : 'Realizar e registrar a "consulta de retorno" ou o "tratamento concluído" no atendimento odontológico (tratamento em andamento).',
  },
}
